const generateRandomString = () => {
  const date = new Date();

  const string =
    (Math.random() + 1).toString(33).substring(5) +
    date.getMilliseconds() +
    date.getSeconds();
  return string;
};

export default generateRandomString;
